'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var index$1 = require('../../00.helper/FormField/index.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-checkbox-slider',
    cnWrapperOptions = "".concat(CLASSNAME, "__wrapper-options"),
    cnWrapperLabel = "".concat(CLASSNAME, "__wrapper-label"),
    cnWrapperInput = "".concat(CLASSNAME, "__wrapper-input"),
    cnInput = "".concat(CLASSNAME, "__input"),
    cnChecker = "".concat(CLASSNAME, "__checker"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnBackgroundLine = "".concat(CLASSNAME, "__background-line"),
    cnLine = "".concat(CLASSNAME, "__line"),
    cnWrapperContent = "".concat(CLASSNAME, "__wrapper-content"),
    cnLabel = "".concat(CLASSNAME, "__label"),
    cnHorizontal = "".concat(CLASSNAME, "--horizontal"),
    cnVertical = "".concat(CLASSNAME, "--vertical"),
    cnDisabled = "".concat(CLASSNAME, "--disabled"),
    cnSelected = "".concat(CLASSNAME, "--selected");
/**
 * 
 */

function CheckboxSlider(_ref) {
  var _classNames2, _classNames3;

  var className = _ref.className,
      disabled = _ref.disabled,
      iconId = _ref.iconId,
      name = _ref.name,
      onChange = _ref.onChange,
      options = _ref.options,
      required = _ref.required,
      selected = _ref.selected,
      type = _ref.type;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className, _rollupPluginBabelHelpers.defineProperty({}, cnDisabled, disabled))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnWrapperOptions, (_classNames2 = {}, _rollupPluginBabelHelpers.defineProperty(_classNames2, cnHorizontal, type === 'horizontal'), _rollupPluginBabelHelpers.defineProperty(_classNames2, cnVertical, type === 'vertical'), _classNames2))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnBackgroundLine, (_classNames3 = {}, _rollupPluginBabelHelpers.defineProperty(_classNames3, cnHorizontal, type === 'horizontal'), _rollupPluginBabelHelpers.defineProperty(_classNames3, cnVertical, type === 'vertical'), _classNames3)),
    style: {
      height: type === 'vertical' ? "".concat(options.length * 6, "em") : '12px'
    }
  }), options.map(function (_ref2, i) {
    var _classNames4, _classNames5;

    var value = _ref2.value,
        label = _ref2.label,
        checked = _ref2.checked;
    return /*#__PURE__*/React__default.createElement("label", {
      key: i,
      className: classNames(cnWrapperLabel, (_classNames4 = {}, _rollupPluginBabelHelpers.defineProperty(_classNames4, cnHorizontal, type === 'horizontal'), _rollupPluginBabelHelpers.defineProperty(_classNames4, cnVertical, type === 'vertical'), _classNames4))
    }, /*#__PURE__*/React__default.createElement("div", {
      className: cnWrapperInput
    }, /*#__PURE__*/React__default.createElement("input", {
      className: cnInput,
      type: "checkbox",
      required: required,
      name: name,
      checked: checked,
      value: value,
      onChange: onChange
    }), /*#__PURE__*/React__default.createElement("div", {
      className: cnChecker,
      onClick: onChange
    })), checked === true || selected === value && /*#__PURE__*/React__default.createElement(Icon, {
      className: cnIcon,
      id: iconId,
      size: "md"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: classNames(cnLine, (_classNames5 = {}, _rollupPluginBabelHelpers.defineProperty(_classNames5, cnHorizontal, type === 'horizontal'), _rollupPluginBabelHelpers.defineProperty(_classNames5, cnVertical, type === 'vertical'), _rollupPluginBabelHelpers.defineProperty(_classNames5, cnSelected, checked || selected === value), _classNames5))
    }), /*#__PURE__*/React__default.createElement("div", {
      className: cnWrapperContent
    }, /*#__PURE__*/React__default.createElement("span", {
      className: classNames(cnLabel, _rollupPluginBabelHelpers.defineProperty({}, cnSelected, checked || selected === value))
    }, label)));
  })));
}
CheckboxSlider.propTypes = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, index$1.propTypes), {}, {
  /** Additional class name */
  className: PropTypes.string,

  /** Not clickable if true */
  disabled: PropTypes.bool,

  /** Id of icon to indicate selection */
  iconId: PropTypes.string.isRequired,

  /** Name of formfield */
  name: PropTypes.string,

  /** Change handler function */
  onChange: PropTypes.func,

  /** Options array */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    checked: PropTypes.bool
  })),

  /** Form validation requirement if true */
  required: PropTypes.bool,

  /** Currently selected value */
  selected: PropTypes.string,

  /** Type of slider */
  type: PropTypes.oneOf(['horizontal', 'vertical'])
});
CheckboxSlider.defaultProps = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, index$1.defaultProps), {}, {
  onChange: function onChange() {
    return void 0;
  },
  required: false,
  type: 'vertical'
});

module.exports = CheckboxSlider;
